// Block registry (spec section 31): block type -> React component.
// New blocks are added with registerBlock() without touching ContentRenderer.

const registry = new Map();

export function registerBlock(type, component) {
  registry.set(type, component);
}

export function getBlockComponent(type) {
  return registry.get(type);
}
